import * as React from 'react';
import Utils from '@nykaa/deals-utils/basic';
import ProductWidgetV2Beauty from './stores/beauty';
import ProductWidgetV2Fashion from './stores/fashion';
const ProductV2Child = (widgetData) => {
    const { isFashionFootlockerStore } = Utils;
    const { store } = widgetData;
    const isFashionFootLockerStore = isFashionFootlockerStore(store);
    return isFashionFootLockerStore ? React.createElement(ProductWidgetV2Fashion, Object.assign({}, widgetData)) : React.createElement(ProductWidgetV2Beauty, Object.assign({}, widgetData));
};
export default ProductV2Child;
